import React, { Component } from "react";
import { connect } from "react-redux";
import { string, bool, func } from "prop-types";

import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { actions as settingsActions } from "reducers/settings";

import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import { Mixpanel } from "util/clickstreaming";

const FORM_ID = "login.step4";

class Step6Content extends Component {
    acceptCommissions = () => {
        Mixpanel.track(FORM_ID, { acceptCommissions: true });
        this.props.dispatch(loginActions.loginStep6(true));
    };

    handleClickDownloadPdf = () => {
        const { dispatch, fileName, activeEnvironmentId } = this.props;
        dispatch(settingsActions.downloadDocumentRequestWithIdEnv(fileName, "commissions", activeEnvironmentId));
    };

    render() {
        const { commissions, isSubmitting, onCancel } = this.props;

        return (
            <>
                <div className="above-the-fold login-desktop-wrapper">
                    {commissions &&
                        <I18n defaultValue={commissions}></I18n>
                    }
                </div>

                <button
                    id="btn-downloaPDF"
                    type="button"
                    className="btn btn-asLink"
                    onClick={() => this.handleClickDownloadPdf()}>
                    <I18n id="generalCommissions.term.download" />
                </button>

                <div className="form-actions">
                    <Button
                        loading={isSubmitting}
                        label="global.accept"
                        bsStyle="primary"
                        onClick={this.acceptCommissions}
                        block
                    />
                    <Button label="global.cancel" bsStyle="outline" onClick={onCancel} block />
                </div>
            </>
        );
    }
}

Step6Content.propTypes = {
    isSubmitting: bool,
    onCancel: func.isRequired,
    dispatch: func.isRequired,
    commissions: string.isRequired,
    fileName: string,
};

Step6Content.defaultProps = {
    isSubmitting: false,
    fileName: "",
};

const mapStateToProps = (state) => ({
    isSubmitting: loginSelectors.getFetching(state),
    activeEnvironmentId: loginSelectors.getEnvironmentIdTemp(state),
});

export default connect(mapStateToProps)(Step6Content);
